export const GET_ENQUIRIES = "GET_ENQUIRIES";
export const FILTER_ENQUIRIES = "FILTER_ENQUIRIES";
export const ADD_ENQUIRIE = "ADD_ENQUIRIE";
export const EDIT_ENQUIRIE = "EDIT_ENQUIRIE";
export const GET_ENQUIRIE = "GET_ENQUIRIE";
export const RESET_ENQUIRIE = "RESET_ENQUIRIE";
export const ENQUIRIES_ERROR = "ENQUIRIES_ERROR";
